/* eslint-disable */
import cumipmt from '../util/_cumipmt';
import pmt from '../util/_pmt';
import amorMonths from '../util/_amor-months';

const calculatorEl = document.querySelector('.business-loan-calculator');

if (calculatorEl) {
  const tableContainerEl = calculatorEl.querySelector('.business-loan-calculator__table');
  const tableHeaderEl = calculatorEl.querySelector('.table-header');
  const showTableButton = calculatorEl.querySelector('.business-loan-calculator__show-amortization');
  const showTableButtonLabel = calculatorEl.querySelector('.business-loan-calculator__show-amortization-label');
  const lengthValueEl = calculatorEl.querySelector('[name="length_value"]');
  const showSecondStep = calculatorEl.querySelector('.business-loan-calculator__second-step');
  const secondStepDivider = calculatorEl.querySelector('.business-loan-calculator__second-step-divider');
  const LengthOfTermRadio = calculatorEl.querySelector('.form-input-inline-wrapper');

  // automatically change the term value by term type
  LengthOfTermRadio.addEventListener('change', e => {
    let chosenTimeLengthValue = lengthValueEl.value

    if(!chosenTimeLengthValue) return;

    e.target.value === 'months' ? chosenTimeLengthValue *= 12 : chosenTimeLengthValue /= 12;
    chosenTimeLengthValue = parseFloat(chosenTimeLengthValue).toFixed(1);

    lengthValueEl.value = chosenTimeLengthValue;
  });

  showTableButton.addEventListener('click', () => {
    tableContainerEl.classList.toggle('is-active');
    showTableButton.classList.toggle('is-active');

    showTableButtonLabel.textContent = showTableButton.classList.contains('is-active') ? 'Hide amortization schedule' : 'Show amortization schedule';
  });

  PubSub.subscribe('clwp.scripts-loaded', () => {
    window.clwpForm.addAction('business-loan-calculator', formData => {
      // show second step block and divider on form submission
      $(showSecondStep).addClass('is-active');
      $(secondStepDivider).css('display', 'block');

      const monthlyPaymentEl = calculatorEl.querySelector('[data-for="monthly_payment"]');
      const totalPaybackEl = calculatorEl.querySelector('[data-for="total_payback"]');
      const totalPrincipalEl = calculatorEl.querySelector('[data-for="total_principal"]');
      const totalMonthsEl = calculatorEl.querySelector('[data-for="total_months"]');

      const graphEl = calculatorEl.querySelector('.business-loan-calculator__bar-graph');
      const graphLabelPrincipalEl = calculatorEl.querySelector('[data-for="principal_pct"]');
      const graphLabelInterestEl = calculatorEl.querySelector('[data-for="interest_pct"]');
      const graphLabelPrincipalTotalEl = calculatorEl.querySelector('[data-for="principal_dollar"]');
      const graphLabelInterestTotalEl = calculatorEl.querySelector('[data-for="interest_dollar"]');
      const graphPrincipalBarEl = calculatorEl.querySelector('.business-loan-calculator__bar-graph__principal');

      const loanAmount = parseFloat(formData.get('loan_amount'));
      const interestRate = parseFloat(formData.get('interest_rate'));
      const lengthTerm = formData.get('length_term');
      const lengthValue = parseFloat(formData.get('length_value'));

      const rate = (interestRate / 100) / 12;

      let lengthMonths = lengthValue;

      // if user selected years, convert to months for calculation
      if (lengthTerm === 'years') {
        lengthMonths *= 12;
      }

      // Calculate total amount of interest
      const totalInterest = cumipmt(rate, lengthMonths, loanAmount, 1, lengthMonths, 0);
      const monthlyPayment = -pmt(rate, lengthMonths, loanAmount, 0, 0);
      const totalPayback = (totalInterest + loanAmount);

      const pctInterest = totalInterest / totalPayback;
      const pctPrincipal = 1 - pctInterest;

      monthlyPaymentEl.innerText = `$${monthlyPayment.toLocaleString()}`;
      totalPaybackEl.innerText = `$${totalPayback.toLocaleString({ minimumFractionDigits: 2 })}`;

      totalPrincipalEl.innerText = `$${loanAmount.toLocaleString()}`;
      totalMonthsEl.innerText = parseFloat(lengthMonths).toFixed(1);

      graphLabelPrincipalEl.innerText = Math.round(pctPrincipal * 100);
      graphLabelInterestEl.innerText = Math.round(pctInterest * 100);

      graphLabelInterestTotalEl.innerText = `$${totalInterest.toLocaleString({ minimumFractionDigits: 2 })}`;
      graphLabelInterestTotalEl.parentNode.style.width = `${Math.round(pctInterest * 100)} %`;

      graphLabelPrincipalTotalEl.innerText = `$${loanAmount.toLocaleString()}`;
      graphLabelPrincipalTotalEl.parentNode.style.width = `${Math.round(pctPrincipal * 100)} %`;

      graphEl.classList.toggle('has-value', true);
      graphPrincipalBarEl.style.width = `${(pctPrincipal * 100)}%`;

      showTableButton.classList.toggle('has-results', true);

      // If user is submitting form again, get rid of the old rows of data first
      const rowLoanDataEls = document.querySelectorAll('.loan-data');

      if(rowLoanDataEls) {
        rowLoanDataEls.forEach(row => row.remove());
      }

      const schedule = amorMonths(monthlyPayment, rate, loanAmount, lengthMonths);
      const tableRows = schedule.map((row, i) => (
          `<tr class="dynamic-table__row loan-data">
            <td class="dynamic-table__cell dynamic-table__cell--text">${i + 1}</td>
            <td class="dynamic-table__cell dynamic-table__cell--text">${monthlyPayment.toLocaleString({ minimumFractionDigits: 2 })}</td>
            <td class="dynamic-table__cell dynamic-table__cell--text">${row.principal.toLocaleString({ minimumFractionDigits: 2 })}</td>
            <td class="dynamic-table__cell dynamic-table__cell--text">${row.interest.toLocaleString({ minimumFractionDigits: 2 })}</td>
            <td class="dynamic-table__cell dynamic-table__cell--text">${row.interestTotal.toLocaleString({ minimumFractionDigits: 2 })}</td>
            <td class="dynamic-table__cell dynamic-table__cell--text">${row.totalBalance.toLocaleString({ minimumFractionDigits: 2 })}</td>
          </tr>`
      )).join('');

      tableHeaderEl.insertAdjacentHTML('afterend', tableRows);

      return new Promise(resolve => {
        resolve({
          success: true,
        });
      });
    });
  });
}
